<template>
  <div class="root">
    <el-menu
      :default-active="$route.path"
      router
      background-color="black"
      text-color="#fff"
      active-text-color="#ffd04b"
      style="overflow: auto; height: 100%"
    >
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['account'])"
        index="/console/account/accountList"
      >
        <i class="el-icon-postcard"></i>
        <span slot="title">账号管理</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['systemSettings'])"
        index="/console/systemConfigManage"
      >
        <i class="el-icon-setting"></i>
        <span slot="title">系统管理</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['version'])"
        index="/console/version/list"
      >
        <i class="el-icon-s-flag"></i>
        <span slot="title">版本管理</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['functionSwitch'])"
        index="/console/function-switch/list"
      >
        <i class="el-icon-switch-button"></i>
        <span slot="title">功能开关</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['zone', 'zone:read'])"
        index="/console/zone/list"
      >
        <i class="el-icon-s-grid"></i>
        <span slot="title">分区</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['redeemCode'])"
        index="/console/redeem-code"
      >
        <i class="el-icon-present"></i>
        <span slot="title">兑换码</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['player'])"
        index="/console/player/playerlist"
      >
        <i class="el-icon-user"></i>
        <span slot="title">玩家</span>
      </el-menu-item>
      <el-menu-item index="/console/payManage">
        <i class="el-icon-coin"></i>
        <span slot="title">付费</span>
      </el-menu-item>
      <el-menu-item index="/console/reportFormsManage">
        <i class="el-icon-notebook-1"></i>
        <span slot="title">报表</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['announcement'])"
        index="/console/announcement/list"
      >
        <i class="el-icon-mic"></i>
        <span slot="title">公告</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['mail'])"
        index="/console/mail"
      >
        <i class="el-icon-message"></i>
        <span slot="title">邮件</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['marquee'])"
        index="/console/marquee/list"
      >
        <i class="el-icon-magic-stick"></i>
        <span slot="title">跑马灯</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['qqGroup'])"
        index="/console/qq-group"
      >
        <i class="el-icon-chat-dot-square"></i>
        <span slot="title">QQ群</span>
      </el-menu-item>

      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['assetHistory'])"
        index="/console/asset-change/asset-change-list"
      >
        <i class="el-icon-wallet"></i>
        <span slot="title">资产流水</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['chat'])"
        index="/console/chat"
      >
        <i class="el-icon-microphone"></i>
        <span slot="title">聊天</span>
      </el-menu-item>
      <!-- <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['blackList'])"
        index="/console/black-list"
      >
        <i class="el-icon-document-delete"></i>
        <span slot="title">黑名单</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['greyList'])"
        index="/console/grey-list"
      >
        <i class="el-icon-notebook-2"></i>
        <span slot="title">灰名单</span>
      </el-menu-item>
      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['whiteList'])"
        index="/console/white-list"
      >
        <i class="el-icon-document-checked"></i>
        <span slot="title">白名单</span>
      </el-menu-item> -->

      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['activity'])"
        index="/console/activity/activityList"
      >
        <i class="el-icon-reading"></i>
        <span slot="title">活动</span>
      </el-menu-item>

      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['guild', 'guild:read'])"
        index="/console/guild/guildList"
      >
        <i class="el-icon-school"></i>
        <span slot="title">公会</span>
      </el-menu-item>

      <el-menu-item
        v-if="$bizutil.hasAnyPrivilege(['corp', 'corp:read'])"
        index="/console/corpflow/corpFlowManagePage"
      >
        <i class="el-icon-school"></i>
        <span slot="title">企业</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {};
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.root {
  background-color: black;
  width: 300px;
  position: fixed;
  bottom: 0px;
}

.el-menu {
  border-right: 0px;
  padding-top: 15px;
}

.el-submenu,
.el-menu-item {
  text-align: left;
}

// 禁用时的样式
.el-slider__runway.disabled .el-slider__bar {
  background-color: #e0eaf3;
}

.el-slider__button {
  width: 10px;
  height: 15px;
  background: #7589d4;
  border: none;
  border-radius: 0;
}

.el-slider__bar {
  background-color: #e0eaf3;
  height: 15px;
}

.el-slider__runway {
  background-color: #e0eaf3;
  height: 15px;
  border-radius: 0;
}

.el-slider__button-wrapper {
  top: -10px;
}

::-webkit-scrollbar {
  display: none;
}
</style>